import styled from 'styled-components';

export const ChatContainer = styled.div`
    display: flex;
    height: calc(100vh - 64px);
    background: #0f0f1e;
    color: #ffffff;
`;

export const ChatHistoryList = styled.div`
    width: ${props => props.isCollapsed ? '0' : '280px'};
    background: #1a1a2e;
    border-right: 1px solid rgba(255, 255, 255, 0.08);
    overflow-y: auto;
    overflow-x: hidden;
    transition: width 0.3s ease;
    opacity: ${props => props.isCollapsed ? '0' : '1'};
    
    &::-webkit-scrollbar {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    
    &::-webkit-scrollbar-thumb {
        background: rgba(138, 92, 217, 0.4);
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: rgba(138, 92, 217, 0.6);
    }
    
    @media (max-width: 768px) {
        display: none;
    }
`;

export const ChatHistoryItem = styled.div`
    padding: 14px 20px;
    cursor: pointer;
    border-bottom: 1px solid rgba(255, 255, 255, 0.03);
    transition: background 0.2s;
    
    &:hover {
        background: rgba(255, 255, 255, 0.03);
    }
    
    &.active {
        background: rgba(138, 92, 217, 0.15);
        border-left: 3px solid #8a5cd9;
    }
`;

export const ChatHeader = styled.div`
    padding: 20px 32px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background: #1a1a2e;
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const ToggleSidebarButton = styled.button`
    width: 40px;
    height: 40px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.04);
    color: #ffffff;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    flex-shrink: 0;
    
    &:hover {
        background: rgba(138, 92, 217, 0.2);
        border-color: rgba(138, 92, 217, 0.4);
    }
    
    &:active {
        transform: scale(0.95);
    }
    
    @media (max-width: 768px) {
        display: none;
    }
`;

export const ChatMessagesContainer = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    position: relative;
    background: #0f0f1e;
    
    &.dragging {
        background: rgba(138, 92, 217, 0.05);
    }
    
    &::-webkit-scrollbar {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    
    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.15);
        border-radius: 3px;
    }
`;

export const ChatInputContainer = styled.div`
    padding: 20px 32px 24px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    background: #1a1a2e;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const MessageBubble = styled.div`
    display: flex;
    gap: 16px;
    padding: ${props => props.sender === 'user' ? '16px 20px' : '20px'};
    border-radius: 16px;
    background: ${props => props.sender === 'user' ? '#8a5cd9' : 'rgba(138, 92, 217, 0.12)'};
    max-width: 85%;
    align-self: ${props => props.sender === 'user' ? 'flex-end' : 'flex-start'};
    box-shadow: ${props => props.sender === 'user' ? '0 4px 12px rgba(138, 92, 217, 0.3)' : 'none'};
    
    @media (max-width: 768px) {
        max-width: 95%;
    }
`;

export const AssistantAvatar = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #8a5cd9, #6a4cb8);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 18px;
    flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(138, 92, 217, 0.4);
`;

export const UserAvatar = styled.div`
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: linear-gradient(135deg, #e0e0e0, #c0c0c0);
    flex-shrink: 0;
`;

export const InputField = styled.input`
    flex: 1;
    padding: 16px 24px;
    border-radius: 28px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.04);
    color: #ffffff;
    font-size: 15px;
    outline: none;
    transition: all 0.2s;
    
    &:focus {
        border-color: #8a5cd9;
        background: rgba(255, 255, 255, 0.06);
        box-shadow: 0 0 0 3px rgba(138, 92, 217, 0.15);
    }
    
    &::placeholder {
        color: rgba(255, 255, 255, 0.4);
    }
    
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const SendButton = styled.button`
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: none;
    background: ${props => props.disabled ? 'rgba(138, 92, 217, 0.4)' : 'linear-gradient(135deg, #8a5cd9, #6a4cb8)'};
    color: #ffffff;
    font-size: 18px;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    flex-shrink: 0;
    box-shadow: ${props => props.disabled ? 'none' : '0 4px 12px rgba(138, 92, 217, 0.4)'};
    
    &:hover:not(:disabled) {
        background: linear-gradient(135deg, #9a6ce9, #7a5cc8);
        transform: scale(1.05);
        box-shadow: 0 6px 16px rgba(138, 92, 217, 0.5);
    }
    
    &:active:not(:disabled) {
        transform: scale(0.98);
    }
`;

export const WelcomeScreen = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 32px;
`;

export const WelcomeTitle = styled.h1`
    font-size: 36px;
    font-weight: 600;
    margin: 0;
    text-align: center;
    color: #ffffff;
    
    @media (max-width: 768px) {
        font-size: 28px;
    }
`;

export const SuggestionButton = styled.button`
    padding: 14px 28px;
    border-radius: 28px;
    border: 1px solid rgba(138, 92, 217, 0.4);
    background: rgba(138, 92, 217, 0.15);
    color: #ffffff;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.2s;
    font-weight: 500;
    
    &:hover {
        background: rgba(138, 92, 217, 0.25);
        border-color: rgba(138, 92, 217, 0.6);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(138, 92, 217, 0.3);
    }
    
    &:active {
        transform: translateY(0);
    }
`;

// Add typing animation styles to global scope
export const GlobalChatStyles = `
    @keyframes typingDot {
        0%, 60%, 100% {
            opacity: 0.3;
        }
        30% {
            opacity: 1;
        }
    }
    
    .typing-dot {
        animation: typingDot 1.4s infinite;
        font-size: 24px;
        line-height: 1;
    }
    
    .typing-dot:nth-child(2) {
        animation-delay: 0.2s;
    }
    
    .typing-dot:nth-child(3) {
        animation-delay: 0.4s;
    }
    
    /* Custom scrollbar for table containers */
    .table-scroll-container::-webkit-scrollbar {
        height: 8px;
    }
    
    .table-scroll-container::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;
    }
    
    .table-scroll-container::-webkit-scrollbar-thumb {
        background: rgba(138, 92, 217, 0.5);
        border-radius: 4px;
    }
    
    .table-scroll-container::-webkit-scrollbar-thumb:hover {
        background: rgba(138, 92, 217, 0.7);
    }
`;
